import { useTranslation } from '../../i18n/i18n';
import { type FaqTopic } from './FaqModal';

type Props = {
  topics: FaqTopic[];
  onSelectTopic: (topic: FaqTopic) => void;
};

export default function HostedNeedHelpSection({
  topics,
  onSelectTopic,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-2 pt-4">
      <h3 className="text-sm font-semibold text-foreground">
        {t('agentStart.needHelp')}
      </h3>
      {topics.map((topic) => (
        <button
          key={topic}
          type="button"
          onClick={() => onSelectTopic(topic)}
          className="text-sm text-muted-foreground underline hover:text-foreground transition-colors"
        >
          {t(`faq.${topic}.title`)}
        </button>
      ))}
    </div>
  );
}
